export default __webpack_public_path__ + "static/media/Upstanding Slash.c49a16c0.png";